import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';
import { noop } from '@babel/types';

const Select = ({ name, onChange, label, items, ...restProps }) => {
    return (
        <select
            className="form-control"
            // defaultValue="selected"
            name={name}
            onChange={onChange}
            {...restProps}
        >
            <option>{label}</option>
            {items.map((item) => {
                return (
                    <option key={item} value={item}>
                        {item}
                    </option>
                );
            })}
        </select>
    );
};

Select.propTypes = {
    // To refrence the Select in the form
    name: PropTypes.string,

    // To invoke a function on change of the value of Select
    onChange: PropTypes.func,

    // name to display as label
    label: PropTypes.string,

    // items for the dropdown
    items: PropTypes.array,
};

Select.defaultProps = {
    label: 'Name of Organization',
    items: [],
    name: null,
    onChange: noop,
};

export default Select;
